import React from 'react';
import { motion } from 'framer-motion';

export default function Background() {
  return (
    <section id="about" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left Column - Background */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-2xl shadow-lg"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-8">BACKGROUND</h2>
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                The Climate Finance and Sustainability Centre (CFSC) was established to address 
                Africa's critical need for expertise and capacity in climate finance and sustainable 
                development. Evolving from the Nationally Determined Contribution-Finance Fellowship 
                Program (NDC-FFP) from 2020 to 2023, the Centre was launched to build long-term 
                skills and mobilize resources for climate adaptation and resilience across the continent.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                As part of its mission, the Centre draws upon a history of engagement with climate 
                action initiatives in Africa. The NDC-FFP program provided a solid foundation for 
                CFSC's establishment, ensuring that the Centre's approach to climate finance is not 
                only grounded in local knowledge and experiences but is also aligned with global 
                trends and international standards in climate finance.
              </p>
            </div>
          </motion.div>

          {/* Right Column - Why CFSC Matters */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative rounded-2xl shadow-lg overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-green-900 to-emerald-900">
              <div 
                className="absolute inset-0 opacity-10"
                style={{
                  backgroundImage: 'url("/images/Climate_Finance.jpg")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
            </div>
            
            <div className="relative z-10 p-8">
              <h2 className="text-4xl font-bold text-white mb-8">WHY CFSC MATTERS</h2>
              <div className="space-y-6">
                <p className="text-lg text-gray-200 leading-relaxed">
                  The urgency of addressing climate change is undeniable, and the establishment of 
                  CFSC is a significant step toward turning the tide for Africa. The Centre is more 
                  than just an educational institution—it's a movement to equip the next generation 
                  with the tools and knowledge to drive meaningful climate action and sustainable 
                  development across Africa.
                </p>
                <p className="text-lg text-gray-200 leading-relaxed">
                  The CFSC will support Africa's transition into a green, resilient economy, helping 
                  the continent meet the challenges of climate change while creating opportunities 
                  for economic growth. By offering targeted capacity-building in climate finance, 
                  carbon markets, sustainable finance models, and environmental policy, CFSC is 
                  setting the stage for a continent-wide transformation towards sustainability.
                </p>
                <p className="text-lg text-gray-200 leading-relaxed">
                  In this critical moment in time, as the world grapples with the impacts of climate 
                  change, the Climate Finance and Sustainability Centre stands as a beacon of hope 
                  and a hub for the education, skills development, and research necessary to build 
                  a greener, more resilient, and sustainable future for Africa.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}